// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__37mCd","col":"styles_col__jblIg"};